import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { WORKFLOWS } from './actions';
import { ProjectDTO, IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';
import { C4ListResponse } from '@domain/interface/c4-list-response';

export const reducers = createReducer(
	initialState,
	on(WORKFLOWS.PROJECTS_LIST.GET, (state) => ({ ...state, loading: true })),
	on(WORKFLOWS.PROJECTS_LIST.SUCCESS, (state, action: C4ListResponse<ProjectDTO>) => ({
		...state,
		loading: false,
		projects: action.data,
		total: action.totalElements,
	})),
	on(WORKFLOWS.PROJECTS_LIST.FAILURE, (state, action) => ({
		...state,
		loading: false,
		error: action.payload.message,
	})),

	on(WORKFLOWS.USERS_LIST.SET, (state, action) => ({
		...state,
		usersList: action.usersList,
	})),

	on(WORKFLOWS.SORT.SET, (state, action) => ({
		...state,
		sort: action.sort,
	})),
	on(WORKFLOWS.FILTERS.SET, (state, action) => ({
		...state,
		filters: action.filters,
	})),

	on(WORKFLOWS.TABS.SET, (state, action) => ({
		...state,
		allTabs: action.allTabs,
	})),

	// update state fields
	on(WORKFLOWS.ACTIVE_TAB.SET, (state, action) => ({
		...state,
		activeTab: action.activeTab,
	})),
	on(WORKFLOWS.USERS_SORT_AND_FILTERS.SET, (state, action) => ({
		...state,
		userSortAndFilters: action.userSortAndFilters,
	})),

	// update project fields
	on(WORKFLOWS.EDIT_PROJECT.UPDATE_DUE_DATE, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.dueDate = action.dueDate;
			}
			return projectDTO;
		}),
	})),
	on(WORKFLOWS.EDIT_PROJECT.UPDATE_CUSTOMER, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.customerDTO = action.customerDTO;
			}
			return projectDTO;
		}),
	})),
	on(WORKFLOWS.EDIT_PROJECT.UPDATE_ASSIGNEE, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.assigneeId = action.assigneeId;
			}
			return projectDTO;
		}),
	})),
	on(WORKFLOWS.EDIT_PROJECT.UPDATE_OUT_OF_NETWORK, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.sendToOutOfNetworkCarriers = action.sendToOutOfNetworkCarriers;
			}
			return projectDTO;
		}),
	})),
	on(WORKFLOWS.EDIT_PROJECT.UPDATE_SUCCESS, (state, { updatedProjects }) => ({
		...state,
		projects: state.projects.map((project) => updatedProjects[project.id] ?? project),
	})),

	on(WORKFLOWS.HISTORICAL_LOADS_COUNT.SUCCESS, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			const matchedProjectedStats = action?.data?.find((stat) => stat.projectId === project.id);
			if (matchedProjectedStats) {
				let projectDTO = Object.assign({}, project);
				projectDTO.loadsCount = (project.loadsCount || 0) + (matchedProjectedStats.loadCount || 0);
				return projectDTO;
			}
			return project;
		}),
	})),

	on(WORKFLOWS.ACTIVE_LOADS_COUNT.SUCCESS, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			const matchedProjectedStats = action?.data?.find((stat) => stat.projectId === project.id);
			if (matchedProjectedStats) {
				let projectDTO = Object.assign({}, project);
				projectDTO.loadsCount = (project.loadsCount || 0) + (matchedProjectedStats.loadsCount || 0);
				return projectDTO;
			}
			return project;
		}),
	}))
);
